<template>
    <div v-if="internalVisible && settingsInitialized" class="modal-overlay">
        <div class="modal-box" v-click-outside="closeModal">
            <div class="icon-wrapper">
                <svg
                    viewBox="0 0 24 24"
                    width="64"
                    height="64"
                    stroke="#e74c3c"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <circle cx="12" cy="16" r="1"></circle>
                </svg>
            </div>
            <h2 class="title">Deneme Sürümünüz Sona Erdi</h2>
            <p class="description">{{ descriptionText }}</p>
            <SupsisButton primary @click="closeModal">Tamam</SupsisButton>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import clickOutside from "@/directives/clickOutside";
import store from "../../store";

export default {
    name: "TrialFinishedModal",
    components: {
        SupsisButton,
    },
    directives: {
        clickOutside,
    },
    data() {
        return {
            internalVisible: false,
            descriptionText: "",
        };
    },
    mounted() {
        this.descriptionText = this.getDescriptionText();
    },
    computed: {
        ...mapState({
            trialFinishedAlertShowed: (state) => state.setting.settings.trialFinishedAlertShowed,
            settings: (state) => state.setting.settings,
            settingsInitialized: (state) => state.setting.initialized,
        }),
        ...mapGetters({
            isSavedCreditCard: "site/isSavedCreditCard",
            paidSubscriptions: "site/paidSubscriptions",
            isTrialMode: "site/isTrialMode",
        }),
    },
    watch: {
        isSavedCreditCard: {
            deep: true,
            handler() {
                this.descriptionText = this.getDescriptionText();
            },
        },
        paidSubscriptions: {
            deep: true,
            handler() {
                this.descriptionText = this.getDescriptionText();
            },
        },
        trialFinishedAlertShowed: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val === false) {
                    this.internalVisible = !this.isTrialMode;
                }
            },
        },
    },
    methods: {
        ...mapActions({
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        getDescriptionText() {
            if (this.isSavedCreditCard && this.paidSubscriptions.length > 0) {
                return "Harika! Deneme süreniz sona erdi ve kayıtlı kartınız üzerinden abonelik ücretlendirmesi otomatik olarak başlayacaktır. Abonelik detaylarını Ayarlar > Faturalandırma bölümünden dilediğiniz zaman inceleyebilirsiniz.";
            }
            if (!this.isSavedCreditCard && this.paidSubscriptions.length > 0) {
                return "Deneme süreniz sona erdi. Hizmeti kesintisiz kullanmaya devam edebilmek için lütfen ödeme bilgilerinizi ekleyin. Ödeme bilgisi ekledikten sonra mevcut abonelikleriniz otomatik olarak aktive edilecektir.";
            }
            return "Deneme süreniz sona erdi. İşletmenizi daha iyi yönetmek için paketlerimizi inceleyebilir ve dilediğiniz zaman yükseltebilir ve istediğiniz zaman iptal edebilirsiniz.";
        },
        async closeModal() {
            this.internalVisible = false;
            const newSettings = {
                ...this.settings,
                trialFinishedAlertShowed: true,
            };
            try {
                await this.updateSettings(newSettings);
            } catch (e) {
                this.setSettingValue({ setting: "trialFinishedAlertShowed", value: true });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    backdrop-filter: blur(2px);
}

.modal-box {
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 480px;
    padding: 48px 40px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 24px;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.icon-wrapper {
    background: #ffeded;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-text-strong-default);
    margin: 0;
}

.description {
    font-size: 16px;
    color: var(--color-text-default);
    max-width: 420px;
    line-height: 1.6;
}

::v-deep .supsis-button.primary {
    min-width: 160px;
    height: 44px;
    font-size: 16px;
}
</style>
